/**
 * Names for files the browser saves. The server names every download in Content-Disposition,
 * but a page served from another origin only sees that header when the API exposes it — and
 * when it cannot, each download must still get a name of its own, or every Excel lands as the
 * same file and the next ones become "(1)", "(2)".
 */

/** The filename in a Content-Disposition header, or `fallback` when there is none to read. */
export function attachmentFilename(contentDisposition, fallback) {
  const header = String(contentDisposition || '');
  const star = /filename\*=(?:UTF-8|utf-8)''([^;]+)/.exec(header);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim());
    } catch {
      return star[1].trim();
    }
  }
  const plain = /filename="?([^";]+)"?/.exec(header);
  return plain ? plain[1].trim() : fallback;
}

/** The Excel of a campaign's failure analysis: all reasons, or one reason by its key. */
export function failureExcelName(campaignId, reason) {
  const what = reason ? String(reason).replace(/_/g, '-') : 'failure-analysis';
  return `CMP-${campaignId}-${what}.xlsx`;
}
